module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_03_A.c0d1cd5e.png";